class CTOGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initFunction();
  }

  initFunction() {
    this.initCarousel();
    this.initThumbsCarousel();
  }

  isRTL() {
    return document.documentElement.dir === 'rtl';
  }

  getGalleryContainer() {
    return this.closest('.js-cto-gallery');
  }

  getThumbsCarousel() {
    const gallery = this.getGalleryContainer();
    return gallery ? $(gallery).find('.js-cto-gallery-thumbs') : $();
  }

  getNavigation() {
    const gallery = this.getGalleryContainer();
    return gallery ? $(gallery).find('.js-cto-gallery-navigation') : $();
  }

  getDots() {
    const gallery = this.getGalleryContainer();
    return gallery ? $(gallery).find('.js-cto-gallery-dots') : $();
  }

  initCarousel() {
    setTimeout(() => {
      const $thumbs = this.getThumbsCarousel();

      $(this).slick({
        prevArrow: `
          <button class="cto-gallery__arrow prev-arrow js-prev-button" type="button">
            <span class="screenreader">Previous</span>
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="m18.192 23.704 1.016-1.118-5.236-5.764 5.236-5.765-1.016-1.118-6.25 6.883 6.25 6.882Z" fill="#333"/>
            </svg>
          </button>
        `,
        nextArrow: `
          <button class="cto-gallery__arrow next-arrow js-next-button" type="button">
            <span class="screenreader">Next</span>
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="m13.957 10.02-1.02 1.124 5.26 5.792-5.26 5.792 1.02 1.124 6.281-6.916-6.28-6.915Z" fill="#333"/>
            </svg>
          </button>
        `,
        dots: true,
        appendArrows: this.getNavigation(),
        appendDots: this.getDots(),
        asNavFor: $thumbs,
        infinite: true,
        rtl: this.isRTL(),
      });

      $(this).on('beforeChange', (slick, currentSlide, nextSlide, slickCurrentSlide) => {
        const slideCount = $(this).slick('getSlick').slideCount || null;
        const $videos = $(this).find('video');

        $videos.each(function(){
          this.pause();
        });

        if (slickCurrentSlide === 0) {
          $thumbs.slick('slickGoTo', 0, false);
        } else if (slickCurrentSlide === slideCount - 1) {
          $thumbs.slick('slickGoTo', slideCount - 1, false);
        }
      });

      $(this).on('afterChange', (slick, currentSlide, slickCurrentSlide) => {
        const $currentSlideVideo = $(this).find('.slick-current video')[0];

        if ($currentSlideVideo) {
          $currentSlideVideo.pause();
        }
      });
    }, 500);
  }

  initThumbsCarousel() {
    const $thumbs = this.getThumbsCarousel();

    if (!$thumbs.length) return;

    // init in center mode for consistant sizing
    $thumbs.slick({
      slidesToShow: 3,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      asNavFor: this,
      infinite: false,
      rtl: this.isRTL(),
    });

    $thumbs.on('beforeChange', (slick, currentSlide, nextSlide, slickCurrentSlide) => {
      const slideCount = $thumbs.slick('getSlick').slideCount || null;
      if (slickCurrentSlide === 0 || slickCurrentSlide === 1) {
        $thumbs.addClass('default-start');
        $thumbs.removeClass('default-end');
      } else if (slickCurrentSlide === slideCount - 1 || slickCurrentSlide === slideCount - 2) {
        const direction = this.isRTL() ? '' : '-';
        const endTransform = `translate3d(calc(${direction}100% ${this.isRTL() ? '-' : '+'} ${$thumbs.width()}px ${this.isRTL() ? '+' : '-'} 34px), 0px, 0px)`;
        $thumbs.get(0).style.setProperty('--end-transform', endTransform);
        $thumbs.addClass('default-end');
        $thumbs.removeClass('default-start');
      } else {
        $thumbs.removeClass('default-start');
        $thumbs.removeClass('default-end');
      }
    });
  }
}

customElements.define('cto-gallery', CTOGallery);
